import { getTableDescriptionMetaWithCache } from 'reporting-snowflake/relational/metadata/table-description-meta';
import { createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
import useFetchUserInfo from './useFetchUserInfo';
import { useEffect, useState } from 'react';
import { isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
const useFetchDependenciesForSnowflakeUpdaters = report => {
  const [reportDeps, setReportDeps] = useState();
  const isSnowflakeReport = isRelationalReport(report);
  const userInfo = useFetchUserInfo();
  useEffect(() => {
    if (isSnowflakeReport && userInfo) {
      const reportDefinition = createRelationalReportFromBaseReport(report);
      const tableDescription = reportDefinition.table;
      getTableDescriptionMetaWithCache(tableDescription).then(tableDescriptionMeta => {
        setReportDeps({
          tableDescriptionMeta,
          userInfo
        });
      }).catch(error => {
        console.error(error);
      });
    }
  }, [userInfo, isSnowflakeReport, report]);
  return reportDeps;
};
export default useFetchDependenciesForSnowflakeUpdaters;